import React, { useState, useEffect } from "react"
import { navigate } from "gatsby"
import { FormikWizard } from "formik-wizard"
import { useToasts } from "react-toast-notifications"
import FailIcon from "../../../images/icons/failed.svg"
import CheckedIcon from "../../../images/icons/checked.svg"

import TinIcon from "../../../images/business/new-tin.svg"
import steps from "./steps"
import TinApplicationWrapper from "../startTinApplication/TinApplicationWrapper"
import Summary from "./views/Summary"
import BusinessTitleCard from "../BusinessCardTitle"
import ConfirmModal from "../ConfirmModal"
import ResponseModal from "../ResponseModal"

const MobileNewTin = () => {
  const [data, setData] = useState({})
  const [tinfees, setTinfees] = useState("5,000")
  const { addToast } = useToasts()
  const [showSummary, setShowSummary] = useState(false)
  const [loading, setLoading] = useState(false)
  const [popup, setPopup] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)
  const [openDoneModal, setOpenDoneModal] = useState(false)
  const [openFailModal, setFailModal] = useState(false)
  const [accountNo, setAccountNo] = useState("")

  const hidePopup = () => {
    setPopup(false)
  }

  // Submit Data
  const handleSubmit = (values) => {
    setShowSummary(true)

    setData({
      account_number:
        typeof window !== `undefined`
          ? localStorage.getItem("nuban_id_24b854967")
          : null,
      company_name: values.business_info.company_name,
      proprietor_name: values.business_info.proprietor_name,
      rc_number: values.business_info.rc_number,
      registration_date: values.business_info.registration_date,
      email: values.business_info.email,
      phone: values.business_info.phone,
      business_address: values.other_info.business_address,
      country: values.other_info.country,
      state: values.other_info.state,
      city: values.other_info.city,
      certificate_of_registration:
        values.additional_documents.certificate_of_registration,
      certificate_of_registration_name:
        values.additional_documents.certificate_of_registration_name,
    })
  }

  const createRecord = async () => {
    setBtnLoading(true)
    let myHeaders = new Headers()
    myHeaders.append("Accept", "application/json")
    myHeaders.append("token", `${localStorage.getItem("mobile_token")}`)

    const formdata = new FormData()

    formdata.append("company_name", data.company_name)
    formdata.append("proprietor_name", data.proprietor_name)
    formdata.append("rc_number", data.rc_number)
    formdata.append("registration_date", data.registration_date)
    formdata.append("email", data.email)
    formdata.append("phone", data.phone)
    formdata.append("business_address", data.business_address)
    formdata.append("country", parseInt(data.country))
    formdata.append("state", data.state)
    formdata.append("city", data.city)
    formdata.append("file1", data.certificate_of_registration)
    formdata.append("file2", data.certificate_of_registration)
    formdata.append(
      "certificate_of_registration_name",
      data.certificate_of_registration_name
    )
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    }

    await fetch(
      `${process.env.GATSBY_SPARKLE_LOCAL_BASE_URL}/api/v1/business/web/registration/tin`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        setBtnLoading(false)
        setOpenDoneModal(true)
        localStorage.clear()
      })
      .catch((err) => {
        if (err.response.data.message === "Token expired") {
          addToast(`${err.response.data.message}, try again`, {
            appearance: "error",
            placement: "top-center",
            autoDismiss: true,
          })
          navigate("/business-support/get-started/")
           localStorage.clear()
        }
        setFailModal(true)
        setBtnLoading(false)
      })
  }

  const initPayment = async () => {
    setPopup(true)
  }

  const goback = () => {
    setOpenDoneModal(false)
    navigate("/business-support/get-started")
  }
  const backToSummary = () => {
    setFailModal(false)
    setPopup(true)
  }
  useEffect(() => {
    const storedData = localStorage.getItem("supportFees")

    if (storedData) {
      const parsedData = JSON.parse(storedData)
      setTinfees(parsedData)
    } else {
      console.log("No data found in localStorage.")
    }
  }, [])
  useEffect(() => {
    const account_no = localStorage.getItem("nuban_id_24b854967")
    if (account_no) {
      setAccountNo(account_no)
    }
  })

  return (
    <div>
      <div className={!showSummary ? "container" : "container d-none"}>
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <BusinessTitleCard
              title="New TIN"
              icon={TinIcon}
              subtitle="Apply for a new Tax identification number (TIN)."
            />

            <div className="business-suport-card my-lg-5 waitlist__form ">
              <FormikWizard
                steps={steps}
                onSubmit={handleSubmit}
                render={TinApplicationWrapper}
              />
            </div>
          </div>
        </div>
      </div>

      <ConfirmModal
        show={popup}
        closePopup={hidePopup}
        handlePayment={createRecord}
        btnLoader={btnLoading}
        account_no={accountNo}
        amount={tinfees.newTin}
      />

      <ResponseModal
        text1="Your payment for your Sparkle business support service was successful!"
        text2="Your application is on the way and we would get back to you 
        in 24-48 hours."
        title="Payment Successful"
        icon={CheckedIcon}
        show={openDoneModal}
        btnAction={goback}
        btnText="Done"
      />
      <ResponseModal
        text1="Your payment for your Sparkle business support service was unsuccessful!"
        text2="Kindly try again"
        title="Payment unsuccessful"
        icon={FailIcon}
        show={openFailModal}
        btnAction={backToSummary}
        btnText="Try Again"
      />

      {showSummary && (
        <Summary
          data={data}
          amount={tinfees.newTin}
          payFee={initPayment}
          setShowSummary={setShowSummary}
          loadingStatus={loading}
        />
      )}
    </div>
  )
}

export default MobileNewTin
